module.exports = __webpack_public_path__ + "static/media/man.fc2c5f6b.png";